<button pButton type="button" icon="pi pi-download" label="Preuzmi" [disabled]="(enabled$ | async) === false"
    (click)="downloadAgentDrugiZapisi()"></button>